import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/park/coupon/shop/page', Object.assign({}, options, { params }));

export const userList = (params, options) =>
request.get('/api/v4ward/park/coupon/shop/users',Object.assign({}, options, { params }));

export const shopList = (params, options) =>
request.get('/api/v4ward/park/coupon/shop/shopSelections',Object.assign({}, options, { params }));

export const syncShop = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/sync', qs.stringify(params),options);

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/coupon/shop/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/coupon/shop/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/coupon/shop/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/coupon/shop/update', params,options);

// v4ward/park/coupon/coupon/selectionList
// 获取券
export const selectionList = (params, options) =>
request.get('/api/v4ward/park/coupon/coupon/selectionList',Object.assign({}, options, { params }));

// 发券详情 列表
export const getCouponsDetailsPage = (params, options) =>
request.get('/api/v4ward/park/coupon/shop/record/page',Object.assign({}, options, { params }));

// 发券详情 新增
export const couponsDetailssave = (params, options) =>
request.post('/api/v4ward/park/coupon/shop/record/save',params,options);
// 发券详情 修改
export const couponsDetailsUpdate = (params, options) =>
request.post('/api/v4ward/park/coupon/shop/record/update',params,options);